import axios from 'axios'

export default {
    // type:
    // 0:id,name
    one:1,//text,name
    two:2,//text,value

    //查询项目类型ID
    queryProjectTypeIds:function (type){
        return axios({
            method:"GET",
            url:"/select/queryProjectTypeId",
            params:{
                type:type,
                userId:JSON.parse(localStorage.getItem("userInfo")).id,
            }
        })
    },
    //查询项目类型名称
    queryProjectTypeNames:function (type){
        return axios({
            method:"GET",
            url:"/select/queryProjectTypeNames",
            params:{
                type:type,
                userId:JSON.parse(localStorage.getItem("userInfo")).id,
            }
        })
    },
    //根据项目类型(汉字) 查找项目ID
    queryProjectIdsByTypeName:function (projectType,type){
        return axios({
            method:"GET",
            url:"/select/queryProjectIdByTypeName",
            params:{
                type:type,
                projectType:projectType,
                userId:JSON.parse(localStorage.getItem("userInfo")).id,
            }
        })
    },
}